import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { useStore } from "../Store";

const SessionRoute = ({ children }: { children: React.ReactNode }) => {
  const { casesStore } = useStore();
  const navigate = useNavigate();

  useEffect(() => {
    const pendingToken = window.__consumeOpaqueCustomerLink?.();
    if (pendingToken) {
      let active = true;
      void casesStore.openLink({ token: pendingToken }).then(success => {
        if (active && !success) navigate("/invalid-link", { replace: true });
      });
      return () => { active = false; };
    }

    if (casesStore.isCaseLoaded || casesStore.sessionState === "loading") return;
    if (casesStore.sessionState === "error") {
      navigate("/invalid-link", { replace: true });
      return;
    }
    let active = true;
    void casesStore.resumeSession().then(success => {
      if (active && !success) navigate("/invalid-link", { replace: true });
    });
    return () => { active = false; };
  }, [casesStore, casesStore.sessionState, casesStore.isCaseLoaded, navigate]);

  return casesStore.isCaseLoaded
    ? <>{children}</>
    : <div className="loading-bar" aria-label="Loading case" />;
};

export default observer(SessionRoute);
